import { useCan } from '@refinedev/core';

/** UI gating only; the server checks every route. Undefined while loading is not a denial. */
export function useExperimentsAccess() {
  const { data: create } = useCan({ resource: 'experiments', action: 'create' });
  const { data: edit } = useCan({ resource: 'experiments', action: 'edit' });
  return { canCreate: create?.can === true, canEdit: edit?.can === true };
}
